import {
  PlaceIcon_default
} from "./chunk-K3O2YXHQ.mjs";
export {
  PlaceIcon_default as default
};
